import { useMutation, useQueryClient } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useMarkAccountIdentityEmailVerified(accountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (identityId: string) => UsersService.markAccountIdentityEmailVerified(accountId, identityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersQueryKeys.identityUserList(accountId) });
    },
  });
}
